import {JSONMapped, jsonProperty} from "json-mapper-reflect";

export class AvdbPricingProductRegionGeoCoverage extends JSONMapped() {
	@jsonProperty()
	afr: AvdbPricingProductRegionGeoCoverageType;

	@jsonProperty()
	asi: AvdbPricingProductRegionGeoCoverageType;

	@jsonProperty()
	can: AvdbPricingProductRegionGeoCoverageType;

	@jsonProperty()
	cen: AvdbPricingProductRegionGeoCoverageType;

	@jsonProperty()
	eur: AvdbPricingProductRegionGeoCoverageType;

	@jsonProperty()
	gre: AvdbPricingProductRegionGeoCoverageType;

	@jsonProperty()
	oce: AvdbPricingProductRegionGeoCoverageType;

	@jsonProperty()
	nz: AvdbPricingProductRegionGeoCoverageType;

	@jsonProperty()
	sam: AvdbPricingProductRegionGeoCoverageType;

	@jsonProperty()
	usa: AvdbPricingProductRegionGeoCoverageType;

	constructor(data?: Partial<AvdbPricingProductRegionGeoCoverage>) {
		super();
		Object.assign(this, data);
	}
}

export enum AvdbPricingProductRegionGeoCoverageType {
	None = "None",
	Partial = "Partial",
	Complete = "Complete",
}
